import { MultiPersonBlock } from './multi-person-block';

export const CreatePeopleBlockRuntime = {
	Component: MultiPersonBlock,
	type: 'create-people-question'
};
